import posthog from 'posthog-js'

let isInitialized = false

export const initPostHog = () => {
  if (typeof window === 'undefined' || isInitialized) {
    return
  }

  posthog.init('phc_Y9doBgaKYZ55NTTfSA66IncJ9wRZqcenOCtTjTl9Nz1', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    disable_session_recording: false,
    session_recording: {
      recordCrossOriginIframes: false,
    },
    capture_pageview: true,
    loaded: () => {
      if (process.env.NODE_ENV === 'development') {
        console.log('p initialized')
      }
    },
  })

  isInitialized = true
}

export default posthog
